import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import pools from './modules/pools'

Vue.use(Vuex)

const prod = process.env.NODE_ENV === 'production'

export default new Vuex.Store({
    modules: {
        auth,
        pools
    },
    strict: !prod,
    plugins: []
})
